import { QueryClient } from '@tanstack/react-query';
import { ApiClientError } from './apiClient.js';

/** Shared TanStack Query client. Don't retry auth/permission errors. */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: (failureCount, error) => {
        if (error instanceof ApiClientError) {
          if ([400, 401, 403, 404, 422].includes(error.status)) return false;
        }
        return failureCount < 2;
      },
      refetchOnWindowFocus: false,
    },
  },
});
